import DraggableScrollbar from './draggableScrollbar'

/**
 * Product Row Popup
 */
let productRowPopup = () => {

  let module = {},
    $productSection,
    $productOpenButton,
    $productCloseButton,
    $productRowContainer,
    $scrollPreviousButton,
    $scrollNextButton,

    categoryId = 0,
    lineId = 0,
    scrollStep = 1,
    scrollHandler,

    dragScroll,

    attachEvents = () => {
      $productOpenButton.on('click', openProductRow);
      $productCloseButton.on('click', closeProductRow);
      $('#productLineSelect').change(lineSelect);
      $('.tabs__icon').on('click', categorySelect);
      $('.product-item').on('click', productItemClick);
      $productRowContainer.on('scroll', productContainerScroll);
      $scrollPreviousButton.on('mousedown', scrollPrevious);
      $scrollPreviousButton.on('mouseup', scrollOver);
      $scrollNextButton.on('click', scrollNext);

      onWindowScroll();
    },

    scrollPrevious = () => {
      let currentScrollLeft = $productRowContainer.scrollLeft();
      $productRowContainer.scrollLeft(currentScrollLeft - 195 * 3); // 195 is the width of 1 element

      // Scroll by holding, slowly
      // scrollHandler = window.setInterval(function () {
      //   let currentScrollLeft = $productRowContainer.scrollLeft();
      //   $productRowContainer.scrollLeft(currentScrollLeft - 12);
      // }, 16);
    },

    scrollOver = () => {
      window.clearInterval(scrollHandler);
    },

    scrollNext = () => {
      let currentScrollLeft = $productRowContainer.scrollLeft();
      $productRowContainer.scrollLeft(currentScrollLeft + 195 * 3); // 195 is the width of 1 element
    },

    productContainerScroll = function (e) {
      // if not dragging
      if (!dragScroll.active) {
        let value = this.scrollLeft * scrollStep;

        document.querySelector('.scrollbar__drag').setAttribute("style", "left: " + value + "px;");
        dragScroll.xOffset = value;
      }

    },

    productItemClick = function (event) {
      event.preventDefault();

      let anchor = $(this).find('a');

      // If tablet (width >= 768px), open the link directly
      // if Mobile, select it first and open on second tap

      if ($(this).hasClass('active')) {
        window.location.href = anchor.attr('href');
      } else {
        $('.product-item').removeClass('active');
        $(this).addClass('active');
        centerProductInContainer($(this));
      }

      if ($(window).width() >= 768) {
        window.location.href = anchor.attr('href');
      }
    },

    lineSelect = function (e) {
      lineId = $(this).find('option:selected').val();

      // Reset category to all
      categoryId = 0;
      $('.tabs__icon').removeClass('active');
      $('.tabs__icon[data-category-id="0"]').addClass('active');

      // Filter
      $('.product-item').show();
      if (lineId != 0) {
        $('.product-item').not('[data-line-id="' + lineId + '"]').hide();
      }

      // check number of items in each category and disable the tabs if neccessary
      $('.tabs__icon').each((_, element) => {
        $(element).removeClass('disabled');
        let _id = $(element).data('category-id');

        if (_id != 0 && $('.product-item[data-category-id="' + _id + '"]:visible').length == 0) {
          $(element).addClass('disabled');
        }
      });

      calculateScrollStep();
    },

    categorySelect = function (event) {

      // if not disabled
      if (!$(this).hasClass('disabled')) {

        // Set category
        categoryId = $(this).data('category-id');
        $('.tabs__icon').removeClass('active');
        $('.tabs__icon[data-category-id="' + categoryId + '"]').addClass('active');

        // Filter
        $('.product-item').show();
        if (categoryId != 0 && lineId != 0) {
          // Both are set, show the subset
          $('.product-item').not('[data-category-id="' + categoryId + '"][data-line-id="' + lineId + '"]').hide();
        } else if (categoryId != 0 && lineId == 0) {
          // Line is set to all, filter only by category
          $('.product-item').not('[data-category-id="' + categoryId + '"]').hide();
        } else if (categoryId == 0 && lineId != 0) {
          // Line is set, category is not
          $('.product-item').not('[data-line-id="' + lineId + '"]').hide();
        }

        calculateScrollStep();
      }
    },

    toggleProductRow = (event) => {
      event.preventDefault();
      $productSection.toggleClass('open');
      $productRowContainer.toggleClass('open');
      $productOpenButton.toggleClass('unstick');
      $('html').toggleClass('overflow-hidden');

      // on close remove scroll event listeners
    },

    openProductRow = (event) => {
      toggleProductRow(event);
      dragScroll.attachListeners();
    },

    closeProductRow = (event) => {
      toggleProductRow(event);
      dragScroll.detachListeners();
    },

    onWindowScroll = () => {

      let prevScrollpos = window.pageYOffset;
      let productButton = document.querySelector('.product-btn');

      window.onscroll = function () {
        if ($('#mobile').is(':visible')) {
          let currentScrollPos = window.pageYOffset;

          if (prevScrollpos > currentScrollPos) {
            productButton.style.bottom = "58px";
          } else {
            productButton.style.bottom = "8px";
          }

          prevScrollpos = currentScrollPos;

        }
      }
    },

    centerProductInContainer = (item) => {
      item.each(function () {
        let containerWidth = $productRowContainer.width();
        let targetWidth = $(this).outerWidth(true);

        // Get the index of item, only for visible items
        let targetIndex = $(this).siblings(":visible").addBack().index($(this));

        let leftScreenOffset = (containerWidth - targetWidth) / 2;
        let leftSiblingOffset = targetWidth * targetIndex;

        let scrollValue = leftSiblingOffset - leftScreenOffset;
        $productRowContainer.scrollLeft(Math.max(0, scrollValue));
      });
    },

    calculateScrollStep = () => {
      let productContainer = document.querySelector('.product-container');
      let scrollbarWidth = document.querySelector('.scrollbar').clientWidth;
      let containerWidth = productContainer.scrollWidth - productContainer.clientWidth;

      // We can't divide by zero
      if (containerWidth === 0) {
        scrollStep = 0;
        // hide the scrollbar
        document.querySelector('.scrollbar').setAttribute("style", "opacity: 0;");
        document.querySelector('.product-row__previous').setAttribute("style", "opacity: 0;");
        document.querySelector('.product-row__next').setAttribute("style", "opacity: 0;");
      } else {
        scrollStep = scrollbarWidth / containerWidth;
        document.querySelector('.scrollbar').setAttribute("style", "opacity: 1;");
        document.querySelector('.product-row__previous').setAttribute("style", "opacity: 1;");
        document.querySelector('.product-row__next').setAttribute("style", "opacity: 1;");
      }
    },

    init = () => {
      $productRowContainer = $('.product-container');

      if (!$productRowContainer.length) {
        return;
      }

      $productOpenButton = $('.js-product-btn');
      $productCloseButton = $('.js-close-btn');
      $productSection = $('.js-product-row');
      $scrollPreviousButton = $('.product-row__previous');
      $scrollNextButton = $('.product-row__next');

      attachEvents();
      calculateScrollStep();

      // Find the selected one and center it
      centerProductInContainer($('.product-item.selected'));

      dragScroll = new DraggableScrollbar({
        scrollbar: '.scrollbar',
        scrollbarThumb: '.scrollbar__drag',
        dragContainer: '#product-row-selection',
        scrollContainer: '.product-container',
        onScroll: function (x) {
          document.querySelector('.product-container').scrollLeft = x / scrollStep;
        }
      })
    };

  module.init = init;

  return module;

};

export default productRowPopup();